/*!
 * devextreme-angular
 * Version: 16.2.5
 * Build date: Tue Feb 28 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var core_1 = require('@angular/core');
var nested_option_1 = require('../../core/nested-option');
var nested_option_2 = require('../../core/nested-option');
var DxoTitleComponent = (function (_super) {
    __extends(DxoTitleComponent, _super);
    function DxoTitleComponent(parentOptionHost, optionHost) {
        _super.call(this);
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    Object.defineProperty(DxoTitleComponent.prototype, "font", {
        get: function () {
            return this._getOption('font');
        },
        set: function (value) {
            this._setOption('font', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoTitleComponent.prototype, "horizontalAlignment", {
        get: function () {
            return this._getOption('horizontalAlignment');
        },
        set: function (value) {
            this._setOption('horizontalAlignment', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoTitleComponent.prototype, "margin", {
        get: function () {
            return this._getOption('margin');
        },
        set: function (value) {
            this._setOption('margin', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoTitleComponent.prototype, "placeholderSize", {
        get: function () {
            return this._getOption('placeholderSize');
        },
        set: function (value) {
            this._setOption('placeholderSize', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoTitleComponent.prototype, "subtitle", {
        get: function () {
            return this._getOption('subtitle');
        },
        set: function (value) {
            this._setOption('subtitle', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoTitleComponent.prototype, "text", {
        get: function () {
            return this._getOption('text');
        },
        set: function (value) {
            this._setOption('text', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoTitleComponent.prototype, "verticalAlignment", {
        get: function () {
            return this._getOption('verticalAlignment');
        },
        set: function (value) {
            this._setOption('verticalAlignment', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoTitleComponent.prototype, "position", {
        get: function () {
            return this._getOption('position');
        },
        set: function (value) {
            this._setOption('position', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoTitleComponent.prototype, "_optionPath", {
        get: function () {
            return 'title';
        },
        enumerable: true,
        configurable: true
    });
    DxoTitleComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'dxo-title',
                    template: '',
                    styles: [''],
                    providers: [nested_option_1.NestedOptionHost]
                },] },
    ];
    DxoTitleComponent.ctorParameters = function () { return [
        { type: nested_option_1.NestedOptionHost, decorators: [{ type: core_1.SkipSelf }, { type: core_1.Host },] },
        { type: nested_option_1.NestedOptionHost, decorators: [{ type: core_1.Host },] },
    ]; };
    DxoTitleComponent.propDecorators = {
        'font': [{ type: core_1.Input },],
        'horizontalAlignment': [{ type: core_1.Input },],
        'margin': [{ type: core_1.Input },],
        'placeholderSize': [{ type: core_1.Input },],
        'subtitle': [{ type: core_1.Input },],
        'text': [{ type: core_1.Input },],
        'verticalAlignment': [{ type: core_1.Input },],
        'position': [{ type: core_1.Input },],
    };
    return DxoTitleComponent;
}(nested_option_2.NestedOption));
exports.DxoTitleComponent = DxoTitleComponent;
var DxoTitleModule = (function () {
    function DxoTitleModule() {
    }
    DxoTitleModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [
                        DxoTitleComponent
                    ],
                    exports: [
                        DxoTitleComponent
                    ],
                },] },
    ];
    DxoTitleModule.ctorParameters = function () { return []; };
    return DxoTitleModule;
}());
exports.DxoTitleModule = DxoTitleModule;
//# sourceMappingURL=title.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/devextreme-angular/ui/nested/title.js
// module id = ../../../../devextreme-angular/ui/nested/title.js
// module chunks = 3